<script>
  import { Button } from "$lib/components/ui/button/index.js";

  let { title, highlightWord, subtitle, ctaButton, footerText } = $props();
</script>

<section class="border-b border-[#3a3a4a]">
  <div class="max-w-4xl mx-auto px-4 py-16 text-center">
    <p class="text-[#888890] text-xs uppercase tracking-widest mb-3">
      ── GET STARTED ──
    </p>
    <h2 class="text-2xl md:text-3xl font-bold text-[#e8e8ec] mb-4">
      {#if highlightWord}
        {@const parts = title.split(highlightWord)}
        {#if parts.length > 1}
          {parts[0]}<span class="text-[#a855f7]">{highlightWord}</span>{parts
            .slice(1)
            .join(highlightWord)}
        {:else}
          {title}
        {/if}
      {:else}
        {title}
      {/if}
    </h2>
    <p class="text-[#a0a0a8] text-sm mb-8 max-w-2xl mx-auto">
      {subtitle}
    </p>

    <Button
      href={ctaButton.href}
      class="bg-[#a855f7] hover:bg-[#9333ea] text-white px-8 py-3 text-sm font-medium"
    >
      {ctaButton.text}
    </Button>

    {#if footerText}
      <p class="mt-6 text-xs text-[#888890]">
        ▸ {footerText}
      </p>
    {/if}
  </div>
</section>
